import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import ProductActionsFormatter from './ProductActionsFormatter';

const ProductColumns = ({
    filterData,
    handleClickBulkItems,
    handleClickUpdateAttachment,
    rowModesModel,
    selectedRowId,
    setRowModesModel,
    setSelectedRowId,
}) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();
    const nameColumn = [
        {
            align: 'left',
            display: 'flex',
            editable: true,
            field: 'name',
            headerName: t('Name'),
            minWidth: 300,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography fontWeight="bold" variant="caption">
                        {row.name}
                    </Typography>
                );
            },
        },
    ];

    let columns = [
        ...nameColumn,
        {
            align: 'left',
            display: 'flex',
            field: 'system',
            headerName: t('System'),
            minWidth: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">
                        {row?.system?.name}
                    </Typography>
                );
            },
        },
        {
            align: 'left',
            display: 'flex',
            field: 'created_at',
            headerName: t('Creation date'),
            minWidth: 200,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography variant="caption">{row.created_at}</Typography>
                );
            },
            width: 200,
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = nameColumn;
    }

    columns = [
        ...columns,
        {
            align: 'left',
            display: 'flex',
            field: '',
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <ProductActionsFormatter
                        filterData={filterData}
                        handleClickBulkItems={handleClickBulkItems}
                        handleClickUpdateAttachment={
                            handleClickUpdateAttachment
                        }
                        row={row}
                        rowModesModel={rowModesModel}
                        selectedRowId={selectedRowId}
                        setRowModesModel={setRowModesModel}
                        setSelectedRowId={setSelectedRowId}
                    />
                );
            },
            sortable: false,
            width: 100,
        },
    ];

    return columns;
};

ProductColumns.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickUpdateAttachment: PropTypes.func,
    rowModesModel: PropTypes.object,
    selectedRowId: PropTypes.func,
    setRowModesModel: PropTypes.func,
    setSelectedRowId: PropTypes.func,
};

export default ProductColumns;
